/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Output_Options_TitleInputs */



/**
* | output |
* | --- |
* | "Output Options" |
*
* @param {Audio_Description_Export_Output_Options_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_output_options_title = /** @type {((inputs?: Audio_Description_Export_Output_Options_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Output_Options_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options de sortie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgabeoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di output")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Параметры вывода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de salida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输出选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("出力オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आउटपुट विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de saída")
	return /** @type {LocalizedString} */ ("Output Options")
});